import type { SocketData } from '@juicyllama/llana-plugins-nuxtjs'
import { defineStore } from 'pinia'
import type { LlanaListResponse, LlanaWhere } from '~/types/llana'
import type { Profile } from '~/types/profile'

const table_name = 'users'
type T = Profile
const default_sort = 'updated_at.desc'
const default_relations = 'users_socials,users_subscriptions'

export class ProfileStore extends baseStore<T> {
	constructor(username: string) {
		const store_name = table_name + '_' + username
		super({
			table_name,
			store_name,
			default_sort,
			default_relations,
		})
	}
}

export const useProfileStore = (username: string) =>
	defineStore(table_name + '_' + username, {
		state: () => <T>{},
		actions: {
			async bindEvents(where?: { [key: string]: string | number }) {
				const { $llanaSubscribe } = useNuxtApp()
				$llanaSubscribe(
					table_name,
					(data: SocketData) => this.get(data.id as number, where),
					(data: SocketData) => this.get(data.id as number, where),
				)
			},
			async get(id: number, where?: { [key: string]: string | number }): Promise<T | undefined> {
				const store = new ProfileStore(username)
				const { state, record } = await store.get(this.$state, id, where)
				this.$state = state
				return record
			},
			async getByUsername(): Promise<T | undefined> {
				const store = new ProfileStore(username)
				const results = await store.search({
					where: [{ field: 'username', value: username, operator: 'equals' }],
					limit: 1,
				})

				if (results.data.length > 0) {
					const record = results.data[0]
					this.$state = record
					return record
				}

				return
			},
			async search(options?: {
							fields?: string[]
							limit?: number
							offset?: number
							where?: LlanaWhere[]
							relations?: string
							page?: string
							sort?: string
						}): Promise<LlanaListResponse<T>> {
							const store = new ProfileStore(username)
							return await store.search(options)
						},
		},
	})
